export interface InsightSegmentedProps<T extends string | number> {
  label: string;
  value: T;
  options: readonly (readonly [T, string])[];
  onChange: (value: T) => void;
}

/** Compact pill switch used for the Insights comparison and activity filters. */
export default function InsightSegmented<T extends string | number>({ label, value, options, onChange }: InsightSegmentedProps<T>) {
  return (
    <div className="insight-segmented" role="radiogroup" aria-label={label}>
      {options.map(([option, text]) => (
        <button
          key={String(option)}
          type="button"
          role="radio"
          aria-checked={option === value}
          className={option === value ? "active" : ""}
          onClick={() => onChange(option)}
        >
          {text}
        </button>
      ))}
    </div>
  );
}
